import { render, staticRenderFns } from "./DynamicLogoComponent.vue?vue&type=template&id=782f3f40&scoped=true&"
import script from "./DynamicLogoComponent.vue?vue&type=script&lang=js&"
export * from "./DynamicLogoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782f3f40",
  null
  
)

export default component.exports